/**
 * DoctorAutoRouter — mobile/tablet use unified CareFlow app; desktop keeps Doctor.
 */
import React from "react";
import { isMobile, isTablet } from "../../utils/device";
import Doctor from "../../pages/Doctor";
import FastBilling from "../../pages/FastBilling";
import "./ModernDoctor.css";

export default function DoctorAutoRouter() {
  if (isMobile() || isTablet()) return <FastBilling />;
  return <Doctor />;
}
